<template>
	<div>
		<div
			class="relativeclass"
			:class="[
				(testConfigData.testID == testDetails.testID &&
					(showTestPreviewStatus || testConfigStatus)) ||
				selTest == testDetails.testID
					? 'changecolor'
					: 'ts-cardv-main',
				testDetails.active ? 'pointer' : '',
			]"
			@click="testDetails.active ? gotoautoqpbuilder() : ''"
		>
			<div class="tp-cardhead">
				<div style="width: 50%">
					<div
						class="ellipsis tp-text d-flex align-items-center"
						v-if="testDetails.active"
					>
						<span class="ml-2"
							><img src="../../../assets/active.svg" alt="" class="mb-1"
						/></span>

						<span
							class="d-inline-block text-truncate ml-1"
							style="max-width: 100%"
							v-b-popover.hover.top="testDetails.name"
						>
							{{ testDetails.name }}
						</span>
					</div>
					<div class="tp-text d-flex align-items-center" v-else>
						<span class="ml-2"
							><img src="../../../assets/inactive.svg" alt="" class="mb-1"
						/></span>

						<span
							class="d-inline-block text-truncate ml-1"
							style="max-width: 100%"
							v-b-popover.hover.top="testDetails.name"
						>
							{{ testDetails.name }}
						</span>
					</div>
					<div
						class="tp-cardoptions d-flex justify-content-end"
						v-if="!testDetails.active"
					>
						<img
							@click.stop="locktestModal = !locktestModal"
							v-if="!testDetails.isLocked"
							v-b-popover.hover.top="'Lock'"
							src="../../../assets/lockiconactive.svg"
							alt=""
							class="m-1"
						/>
						<img
							@click.stop="locktestModal = !locktestModal"
							v-else
							v-b-popover.hover.top="'Unlock'"
							src="../../../assets/lockicoinactive.svg"
							alt=""
							class="m-1"
						/>
						<img
							v-if="
								(!showTestPreviewStatus ||
									testConfigData.testID != testDetails.testID) &&
									roles.includes('GET_AUTO_QUESTION') &&
									this.roles.includes('GET_AUTO_SECTION')
							"
							@click="(showPreviewTest = true), saveTestPreview()"
							v-b-popover.hover.top="'Test Preview'"
							src="../../../assets/preview eye.svg"
							alt=""
							class="autogen-view-eye pointer"
						/>
						<img
							v-else-if="
								(showTestPreviewStatus ||
									testConfigData.testID == testDetails.testID) &&
									roles.includes('GET_AUTO_QUESTION') &&
									this.roles.includes('GET_AUTO_SECTION')
							"
							@click="(showPreviewTest = false), saveTestPreview()"
							v-b-popover.hover.top="'Close Preview'"
							src="../../../assets/visibility_off.svg"
							alt=""
							class="autogen-view-eye pointer"
						/>
						<div
							v-if="roles.includes('ACTIVATE_AUTO_TEST')"
							class="mt-1 pointer"
							@click="testModal = !testModal"
							v-b-popover.hover.top="'Activate'"
						>
							<img src="../../../assets/activate.svg" alt="" />
						</div>
					</div>

					<div v-if="testDetails.active">
						<div class="tp-cardoptions pointer" v-if="!testDetails.editoption">
							<img
								@click.stop="locktestModal = !locktestModal"
								v-b-popover.hover.top="'Lock'"
								v-if="!testDetails.isLocked"
								src="../../../assets/lockiconactive.svg"
								alt=""
								class="m-1"
							/>
							<img
								@click.stop="locktestModal = !locktestModal"
								v-else
								v-b-popover.hover.top="'Unlock'"
								src="../../../assets/lockicoinactive.svg"
								alt=""
								class="m-1"
							/>

							<img
								v-if="roles.includes('GET_AUTO_CONFIG')"
								v-b-popover.hover.top="'Configuration'"
								src="../../../assets/icons/testconfigicon.svg"
								@click.stop="saveTestConfig(testDetails)"
								alt=""
								class="m-1"
							/>

							<img
								v-if="
									(!showTestPreviewStatus ||
										testConfigData.testID != testDetails.testID) &&
										roles.includes('GET_AUTO_QUESTION') &&
										this.roles.includes('GET_AUTO_SECTION')
								"
								@click.stop="(showPreviewTest = true), saveTestPreview()"
								v-b-popover.hover.top="'Test Preview'"
								src="../../../assets/preview eye.svg"
								alt=""
								class="m-1 pointer"
							/>
							<img
								v-else-if="
									showTestPreviewStatus &&
										testConfigData.testID == testDetails.testID &&
										roles.includes('GET_AUTO_QUESTION') &&
										this.roles.includes('GET_AUTO_SECTION')
								"
								@click.stop="(showPreviewTest = false), saveTestPreview()"
								v-b-popover.hover.top="'Close Preview'"
								src="../../../assets/visibility_off.svg"
								alt=""
								class="m-1 pointer"
							/>

							<img
								v-if="
									roles.includes('PUT_AUTO_TEST') ||
										roles.includes('DELETE_AUTO_TEST') ||
										roles.includes('GET_AUTO_INDIVIDUAL') ||
										roles.includes('GET_AUTO_GROUP')
								"
								src="../../../assets/ellipseicon.svg"
								alt=""
								class="m-1"
								v-b-popover.hover.top="'View More'"
								@click.stop="$emit('test-card-option', testDetails.testID)"
							/>
						</div>

						<transition name="slide-fade">
							<div
								class="tp-cardeditoptions pointer"
								v-if="testDetails.editoption"
							>
								<img
									v-if="
										roles.includes('GET_AUTO_INDIVIDUAL') ||
											roles.includes('GET_AUTO_GROUP')
									"
									src="../../../assets/singleusericon.svg"
									v-b-popover.hover.top="'Share'"
									class="m-1"
									:class="disableShare ? 'disableSharing' : ''"
									@click.stop="disableShare ? '' : goToShare()"
									alt=""
								/>
								<img
									v-if="roles.includes('PUT_AUTO_TEST')"
									src="../../../assets/pencilicon.svg"
									v-b-popover.hover.top="'Edit'"
									@click.stop="(testModal = !testModal), copyingVal()"
									alt=""
									class="m-1"
								/>
								<img
									v-if="roles.includes('DELETE_AUTO_TEST')"
									src="../../../assets/deleteicon.svg"
									v-b-popover.hover.top="'Delete'"
									@click.stop="deleteModal = !deleteModal"
									alt=""
									class="m-1"
								/>

								<img
									src="../../../assets/closeicon.svg"
									v-b-popover.hover.top="'Close'"
									alt=""
									class="m-1"
									@click.stop="$emit('test-card-option', null)"
								/>
							</div>
						</transition>
					</div>
				</div>
			</div>

			<div class="ts-card-content">
				<div>
					<div class="mt-2">
						<span
							:class="
								testDetails.difficultyLevel == 'Easy'
									? 'pinktext'
									: testDetails.difficultyLevel == '--'
									? 'disabletext'
									: 'greytext'
							"
							>Easy / </span
						><span
							:class="
								testDetails.difficultyLevel == 'Medium'
									? 'pinktext'
									: testDetails.difficultyLevel == '--'
									? 'disabletext'
									: 'greytext'
							"
							>Medium </span
						><span
							:class="
								testDetails.difficultyLevel == 'Difficult'
									? 'pinktext'
									: testDetails.difficultyLevel == '--'
									? 'disabletext'
									: 'greytext'
							"
							>/ Difficult</span
						>
					</div>
				</div>
				<div>
					<div class="mt-2">
						<span
							:class="
								testDetails.autoCorrection == true ? 'pinktext' : 'greytext'
							"
							>Auto Corrected / </span
						><span
							:class="
								testDetails.autoCorrection == false ? 'pinktext' : 'greytext'
							"
						>
							Evaluated
						</span>
					</div>
				</div>
			</div>
			<div
				class="tp-cardv-submain d-flex justify-content-around mt-3 align-items-center"
				:class="{ pointer: testDetails.active }"
			>
				<div class="d-flex align-items-center flex-column">
					<span v-if="testDetails.numberOfSections < 10" class="greennumbertext"
						>0{{ testDetails.numberOfSections }}</span
					>
					<span v-else class="greennumbertext">{{
						testDetails.numberOfSections
					}}</span>
					<span class="tp-cardhead">Sections</span>
				</div>
				<div class="d-flex align-items-center flex-column">
					<span v-if="testDetails.candidateCount < 10" class="bluenumbertext"
						>0{{ testDetails.candidateCount }}</span
					>
					<span v-else class="bluenumbertext">{{
						testDetails.candidateCount
					}}</span>
					<span class="tp-cardhead">Candidates</span>
				</div>
				<div class="d-flex align-items-center flex-column">
					<span v-if="testDetails.marks < 10" class="yellownumbertext"
						>0{{ testDetails.marks }}</span
					>
					<span v-else class="yellownumbertext">{{ testDetails.marks }}</span>
					<span class="tp-cardhead">Marks</span>
				</div>
			</div>
			<div class="inactive-text-box" v-if="!testDetails.active">
				<div class="inactive-txt">Inactive</div>
			</div>
		</div>

		<!---------------------------- Edit Test Modal Start----------------------------->

		<b-modal
			id="testConfgauto"
			v-model="testModal"
			centered
			hide-footer
			hide-header
			size="lg"
		>
			<div class="modalheading">
				<span v-if="testDetails.active">Edit Test</span>
				<span v-else>Activate Test</span>
			</div>
			<div @click="closetestmodal()" class="xMarkCancel pointer">
				<img src="../../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<b-row>
				<b-col>
					<div class="topDiv mt-3">
						<label class="fieldsetStyle"
							>Test Name &nbsp;<span class="asterik">*</span></label
						>
						<b-form-input
							v-on:keyup.enter="editTest()"
							class="inputField"
							id="input-1"
							placeholder="Enter here"
							v-model.trim="$v.clone.name.$model"
							:class="{ error: $v.clone.name.$error }"
							autofocus
							type="text"
						></b-form-input>
						<div
							style="
                position: absolute;
                top: 5px;
                right: 12px;
                background-color: #fff;
              "
							v-if="$v.clone.name.$dirty && !$v.clone.name.required"
							v-b-popover.hover.top.v-danger="{ content: 'Required' }"
							variant="primary"
						>
							<img src="../../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							style="
                position: absolute;
                top: 5px;
                right: 12px;
                background-color: #fff;
              "
							v-if="!$v.clone.name.maxLength && $v.clone.name.required"
							v-b-popover.hover.top.v-danger="{
								content: 'Should not exceed 128 characters',
							}"
							variant="primary"
						>
							<img src="../../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
				</b-col>
				<b-col>
					<div class="d-flex mt-3">
						<span style="color: #545454"
							>Public Availability <span class="asterik">*</span></span
						>
						<b-form-radio-group
							class="ml-3"
							:options="options"
							v-model="clone.publicAvailability"
							value-field="item"
							text-field="name"
							disabled-field="notEnabled"
							size="sm"
						></b-form-radio-group>
					</div>
				</b-col>
			</b-row>

			<div class="d-flex justify-content-end mt-3">
				<b-button class="addbtn">
					<span v-if="testDetails.active == true" @click="editTest()">
						Update</span
					>
					<span
						v-else-if="roles.includes('ACTIVATE_AUTO_TEST')"
						@click="editModalTest()"
						>Activate</span
					>
				</b-button>
			</div>
		</b-modal>
		<!---------------------------- Edit Test Modal End----------------------------->
		<!-----------------  Delete Popup starts -------->
		<b-modal
			id="deleteTest"
			v-model="deleteModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				Caution
				<img src="../../../assets/deletepopupicon.svg" alt="" />
			</div>
			<div @click="closedeletemodal()" class="xMarkCancel pointer">
				<img src="../../../assets/xmark.svg" alt="" />
			</div>
			<hr />
			<div class="mt-3 text-break caution-modal-text text-break">
				<span>Are you sure you want to delete "{{ clone.name }}" ?</span>
			</div>
			<div class="normaltext">
				<span class="asterik">*</span
				><span>Please note this action cannot be undone</span>
			</div>
			<div class="d-flex align-items-center justify-content-end mt-3">
				<b-button class="addbtn" @click="deleteAutoTest()">Delete</b-button>
			</div>
		</b-modal>

		<!-----------------  Delete Popup ends -------->
		<template v-if="locktestModal">
			<TestLock
				:locktestModal="locktestModal"
				@hide="locktestModal = false"
				:testDetails="testDetails"
				:topicID="topicID"
				:context="this"
				@resetPagination="$emit('resetPagination')"
			/>
		</template>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { putAutoGenerate } from "../../../utils/apiFunctions";
import successToast from "../../mixin/toast.js";
import errorToast from "../../mixin/toast";
import { required, maxLength } from "vuelidate/lib/validators";
import TestLock from "../../../controllers/Test/modals/TestLock.vue";

export default {
	name: "Autotestcardview",
	mixins: [successToast, errorToast],
	props: {
		showindex: Number,
		selectedTest: {},
		testDetails: {},
		simp: Boolean,
		type: String,
		sort: Number,
		showfiltercard: Boolean,
	},
	data() {
		return {
			locktestModal: false,
			selTest: "",
			clone: { ...this.testDetails },
			editoptions: false,
			pop1: false,
			show: false,
			DifficultyLevel: "Easy",
			deleteModal: false,
			testModal: false,
			showTestConfig: false,
			showPreviewTest: false,
			publicAvailability: false,
			active: false,
			btnDisable: true,
			config_status: true,
			options: [
				{
					item: true,
					name: "Yes",
				},
				{
					item: false,
					name: "No",
				},
			],
		};
	},
	validations: {
		clone: {
			name: {
				required,
				maxLength: maxLength(128),
			},
		},
	},
	beforeDestroy() {
		this.$store.commit("testVUEX/setPreviewLoading", false);
		this.showPreviewTest = false;
		this.testDetails = {};
	},
	computed: {
		...mapGetters("autotestVUEX", {
			tests: "getTests",
			showTestPreviewStatus: "getShowTestPreviewStatus",
			topicID: "getAutoTopicID",
			testConfigData: "getTestConfigData",
		}),
		...mapGetters("autotestVUEX", {
			testConfigStatus: "getTestConfigStatus",
		}),
		...mapGetters(["roles"]),

		disableShare() {
			return !(
				this.testDetails.noOfQuestions !== 0 &&
				this.testDetails.allSectionsHaveQuestions
			);
		},
	},
	created() {
		this.testDetails["activecard"] = false;
		this.config_status = true;
	},
	components: {
		TestLock,
	},
	methods: {
		copyingVal() {
			this.selTest = this.testDetails.testID;
			this.clone = { ...this.testDetails };
		},
		goToShare() {
			if (
				this.roles.includes("GET_AUTO_INDIVIDUAL") ||
				this.roles.includes("GET_AUTO_GROUP")
			) {
				this.$router.push({
					// path: "/sharewithpeople",
					// path: `/autogenerate/sharewithpeople/${this.topicID}/${this.testDetails.testID}/${this.testDetails.name}`
					name: "ShareWithPeopleAutogenerate",
					params: {
						topicID: this.topicID,
						testID: this.testDetails.testID,
						testName: this.testDetails.name,
					},
					query: {
						type: this.type,
						sort: this.sort,
						autoqp: "outside",
					},
				});
			}
		},
		gotoautoqpbuilder() {
			if (
				this.roles.includes("GET_AUTO_QUESTION") &&
				this.roles.includes("GET_AUTO_SECTION")
			) {
				this.$router.push({
					// path: `/autogenerate/autoqpbuilder/${this.testDetails.testID}/${this.testDetails.name}`
					name: "AutoQPBuilder",
					params: {
						testID: this.testDetails.testID,
						testName: this.testDetails.name,
						topicID: this.topicID,
					},
					query: {
						type: this.type,
						sort: this.sort,
						available: this.testDetails.publicAvailability,
					},
				});
			} else {
				this.errorToast("You don't have access to this page!");
			}
		},
		async editTest() {
			this.$v.clone.name.$touch();
			if (!this.$v.clone.name.$invalid) {
				let payload = this.clone;
				payload.topicID = this.clone.topicID;
				try {
					const response = await putAutoGenerate(payload);
					if (response.status == 200) {
						this.$emit("lengthofTotalTestsWhenEdited", this.showindex, payload);
						this.$store.commit("autotestVUEX/saveAutoTest", payload);
						this.successToast("Test updated successfully!");
						this.selTest = "";
					} else {
						this.errorToast("Something went wrong!");
					}
				} catch (error) {
					this.errorToast("Something went wrong!");
					throw new Error(`Failed! Updating roles:${error.status}`);
				}
				this.$bvModal.hide("testConfgauto");

				this.editoptions = false;
			}
		},
		async editModalTest() {
			if (!this.$v.clone.name.$invalid) {
				this.clone.active = true;

				let payload = this.clone;
				payload.topicID = this.clone.topicID;
				try {
					const response = await putAutoGenerate(payload);
					if (response.status == 200) {
						this.$emit("resetPagination");
						this.$emit("lengthofTotalTopicsWheneActivated");
						this.$store.commit("autotestVUEX/deleteInactiveTest", this.clone);
						this.$nextTick(() => {
							this.successToast("Test activated successfully!");
						});
						this.selTest = "";
					} else if (response.status == 409) {
						this.errorToast(`${response.data.data.Details}`);
					} else {
						this.errorToast(" Something went wrong!");
					}
				} catch (error) {
					this.errorToast("Something went wrong!");
				}

				this.$bvModal.hide("testConfgauto");
			}
		},

		saveTestConfig(data) {
			this.$emit("filterCard");
			let payload = {};
			payload = data;
			this.testDetails.activecard = !this.testDetails.activecard;

			if (!this.showTestConfig) {
				this.showTestConfig = true;

				this.$store.commit("autotestVUEX/saveShowTestConfig", {
					config_data: payload,
					config_status: this.showTestConfig,
				});
			} else if (payload.testID != this.testConfigData.testID) {
				this.$store.commit("autotestVUEX/saveShowTestConfig", {
					config_data: payload,
					config_status: this.showTestConfig,
				});
			} else {
				this.showTestConfig = !this.showTestConfig;
				this.$store.commit("autotestVUEX/saveShowTestConfig", {
					config_data: {
						testID: "",
					},
					config_status: this.showTestConfig,
				});
			}
			if (this.config_status) {
				this.config_status = false;
			}

			if (this.showTestConfig) {
				this.$store.commit("autotestVUEX/saveshowPreviewTest", {
					preview_status: false,
				});
			}
		},
		async saveTestPreview() {
			this.$emit("filterCard");
			this.$store.commit("testVUEX/setPreviewLoading", true);
			this.testDetails.activecard = !this.testDetails.activecard;
			let payload = {};
			if (this.testDetails.active || this.showPreviewTest) {
				payload = this.testDetails;
			}
			this.$store.commit("autotestVUEX/saveshowPreviewTest", {
				preview_status: this.showPreviewTest,
			});
			this.showTestConfig = false;
			this.$store.commit("autotestVUEX/saveShowTestConfig", {
				config_data: payload,
				config_status: this.showTestConfig,
			});
			await this.$store.dispatch(
				"autotestVUEX/getPerticularAutoTest",
				this.testDetails.testID
			);
			this.$store.commit("testVUEX/setPreviewLoading", false);
		},
		closedeletemodal() {
			this.$bvModal.hide("deleteTest");
			this.editoptions = false;
		},
		deleteAutoTest() {
			this.$store
				.dispatch("autotestVUEX/deleteAutoTest", this.testDetails)
				.then((res) => {
					if (res.status == 200) {
						this.$emit("resetPagination");
						this.$nextTick(() => {
							this.successToast("Test deleted successfully!");
						});
					} else {
						this.errorToast("Something went wrong!");
					}
				})
				.catch((err) => {
					this.errorToast("Something went wrong!");
					throw err;
				});
			this.$bvModal.hide("deleteTest");
		},
		closetestmodal() {
			this.$bvModal.hide("testConfgauto");
			this.editoptions = false;
			this.selTest = "";
		},
	},
};
</script>

<style scoped>
.inactive-text-box {
	background: #ffeeee;
	border-radius: 3px;
	padding: 4px;
	position: absolute;
	bottom: 3px;

	width: 269px;
	text-align: center;
}

.autogen-view-eye {
	margin: 5px;
}

.inactive-txt {
	font-weight: 400;
	font-size: 12px;
	color: #ad1927;
}

.relativeclass {
	position: relative;
}

.changecolor {
	background: #ebf5fe;
	border: 2px solid #84bae7;
	width: 302px;
	height: 221px;
	border-radius: 8px;
	padding: 15px;
}

.slide-fade-leave-active {
	transition: all 0.3s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
	transform: translateX(10px);
	opacity: 0;
}
#testConfgauto .modal-body {
	padding: 1rem;
}
</style>
